<template>
  <div class="page-header-index-wide">
    <a-row :gutter="24">
      <a-col :sm="24" :md="16" :xl="8" :style="{ marginBottom: '24px' }">
        <a-tooltip title="仓库简介" slot="action">
          <a-icon type="info-circle-o" />
        </a-tooltip>
        <a-card class="antd-pro-pages-dashboard-analysis-salesCard" :loading="loading" :bordered="false" :title="warehouse.name" >
          <div>
            <ve-map :data="chartMapData" :settings="chartMapSettings" height="300px"></ve-map>
          </div>
        </a-card>
      </a-col>

      <a-col :sm="24" :md="16" :xl="8" :style="{ marginBottom: '24px' }">
        <a-card class="antd-pro-pages-dashboard-analysis-salesCard" :loading="loading" :bordered="false" title="雇员" >
          <ve-pie :data="chartEmpData" :settings="chartEmpSettings" height="300px"/>
        </a-card>
      </a-col>

      <a-col :sm="24" :md="16" :xl="8" :style="{ marginBottom: '24px' }">
        <a-tooltip title="仓库货位总数及分布" slot="action">
          <a-icon type="info-circle-o" />
        </a-tooltip>
        <a-card :bordered="false" :loading="loading" :title="$t('business.label.location')"
                class="antd-pro-pages-dashboard-analysis-salesCard">
          <ve-gauge :data="chartLocData" :settings="chartLocSettings" height="300px"/>
        </a-card>
      </a-col>

    </a-row>

    <a-card :loading="loading" :bordered="false" :body-style="{padding: '0'}">
      <div class="salesCard">
        <a-tabs default-active-key="1" size="large" :tab-bar-style="{marginBottom: '24px', paddingLeft: '16px'}">
          <div class="extra-wrapper" slot="tabBarExtraContent">
            <a-range-picker ref="rangePicker" v-model="rangeDate" @change="dateChange" :style="{width: '256px'}"/>
          </div>
          <a-tab-pane tab="发货明细数" key="2">
            <a-row>
              <a-col :xl="24" :lg="24" :md="12" :sm="24" :xs="24">
                <ve-histogram
                  :data="chartShipmentData"
                  :settings="chartShipmentSettings"
                  :extend="chartShipmentExtend"/>
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane loading="true" tab="ASN明细数" key="1">
            <a-row>
              <a-col :xl="24" :lg="24" :md="24" :sm="24" :xs="24">
                <ve-histogram :data="chartAsnData" :settings="chartAsnSettings" :extend="chartAsnExtend"/>
              </a-col>

            </a-row>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-card>

  </div>
</template>

<script>
    import {findAll} from '@/api/Api';
  import moment from 'moment'
  import {
    Bar,
    ChartCard,
    MiniArea,
    MiniBar,
    MiniProgress,
    MiniSmoothArea,
    NumberInfo,
    RankList,
    Trend
  } from '@/components'
  import { mixinDevice } from '@/utils/mixin'
  import { WAREHOUSE } from '@/store/mutation-types'
  import Vue from 'vue'

  export default {
    name: 'Analysis',
    mixins: [mixinDevice],
    components: {
      ChartCard,
      MiniArea,
      MiniBar,
      MiniProgress,
      RankList,
      Bar,
      Trend,
      NumberInfo,
      MiniSmoothArea
    },
    data () {
      this.warehouse = Vue.ls.get(WAREHOUSE)
      this.rangeDate=[moment().subtract(200,'days'),moment()]

      this.locCnt()
      //employee
      this.empCnt()
      //ASN,Shipment
      this.dateChange(this.rangeDate)

      return {
        shipmentParam:{},
        rangeDate:[],
        chartLocData:{},
        chartLocSettings:{},
        chartEmpData:{},
        chartEmpSettings:{},
        chartAsnData:{},
        chartAsnSettings:{},
        chartAsnExtend:{},
        chartAsnXAxisSet:{},
        chartShipmentData:{},
        chartShipmentSettings:{},
        chartShipmentExtend:{},
        loading: true,
        pieStyle: {
          stroke: '#fff',
          lineWidth: 1
        },
        chartMapSettings:{
          position: 'province/guangdong'
        },
        chartMapData: {
          columns: ['位置', '面积(平方米)'],
          rows: [
            { '位置': '清远市', '面积(平方米)': 10000 }
          ]
        }
      }
    },
    created () {
      setTimeout(() => {
        this.loading = !this.loading
      }, 1000)
    },
    methods: {
      dateChange(dates) {
        this.rangeDate = dates
        this.shipmentParam = {
          whId: this.warehouse.id,
          dateFilter: {
            start: dates[0].format('YYYY-MM-DD HH:mm:ss'),
            end: dates[1].format('YYYY-MM-DD HH:mm:ss')
          }
        }
        const _that = this
          findAll('shipmentDashboardFactory', this.shipmentParam).then(res => {
          //alert(JSON.stringify(res))
          _that.chartShipmentData = {
            columns: ['countDate', 'count', 'finishedCount'],
            rows: res
          }
          _that.chartShipmentSettings = {
            //stack: { 'count': [ 'finishedCount'] },
            metrics: ['count', 'finishedCount'],
            labelMap: { 'count': '明细总数', 'finishedCount': '已完成数量', 'countDate': '日期' }
          }
          _that.chartShipmentExtend = {
            series: {
              label: { show: true, position: 'top' }
            },
            color: ['#fdcc74', '#00b436', '#4f91f1', '#4ad2ff'],
          }
        }).catch(error => {
          this.requestFailed(error)
        })
        //ASN
          findAll('purchaseDashboardFactory', this.shipmentParam).then(res => {
          //alert(JSON.stringify(res))
          _that.chartAsnData = {
            columns: ['countDate', 'count', 'finishedCount'],
            rows: res
          }
          _that.chartAsnSettings = {
            //stack: { 'count': [ 'finishedCount'] },
            metrics: ['count', 'finishedCount'],
            labelMap: { 'count': '明细总数', 'finishedCount': '已完成数量', 'countDate': '日期' }
          }
          _that.chartAsnExtend = {
            series: {
              label: { show: true, position: 'top' }
            },
            color: ['#fdcc74', '#00b436', '#4f91f1', '#4ad2ff'],
          }
        }).catch(error => {
          this.requestFailed(error)
        })
      },
      locCnt() {
        const _that = this
          findAll('locationFactory', {'warehouse.id': this.warehouse.id, 'locationType': 5}).then(res => {
          //alert(JSON.stringify(res))
          const locCnt = res.length
          _that.chartLocSettings = {
            seriesMap: {
              'loc': {
                radius: '100%',
                min: 0,
                max: locCnt,
                splitNumber: 5
              }
            },
            labelMap: {
              'loc': '货位占用'
            },
            dataName: {
              'loc': '个'
            }
          }
        }).catch(error => {
          this.requestFailed(error)
        })

        let locNotEmpty = 0
          findAll('locationFactory', {
              'warehouse.id': this.warehouse.id,
              'locationType': 5,
              'locationStatus': 2
          }).then(res => {
          locNotEmpty = res.length
              findAll('locationFactory', {
                  'warehouse.id': this.warehouse.id,
                  'locationType': 5,
                  'locationStatus': 3
              }).then(res => {
            locNotEmpty =locNotEmpty + res.length
            //alert(JSON.stringify(res))
            _that.chartLocData = {
              columns: ['type', 'count'],
              rows: [{ 'type': 'loc', 'count': locNotEmpty }]
            }
          })

        }).catch(error => {
          this.requestFailed(error)
        })
      },
      empCnt() {
        const _that = this
          findAll('departmentDashboardFactory', {'department.id': ''}).then(res => {
          //alert(JSON.stringify(res))
          _that.chartEmpData = {
            columns: ['departmentName', 'userCount'],
            rows: []
          }
          res.map(a => {
            _that.chartEmpData.rows.push({'departmentName':a.department.name,
              'userCount':a.userCount
            })
          })

          _that.chartEmpSettings = {
            radius: '70'
          }
        }).catch(error => {
          this.requestFailed(error)
        })
      }

    }
  }
</script>

<style lang="less" scoped>
  .extra-wrapper {
    line-height: 55px;
    padding-right: 24px;

    .extra-item {
      display: inline-block;
      margin-right: 24px;

      a {
        margin-left: 24px;
      }
    }
  }

  .antd-pro-pages-dashboard-analysis-twoColLayout {
    position: relative;
    display: flex;
    display: block;
    flex-flow: row wrap;

    &.desktop div[class^=ant-col]:last-child {
      position: absolute;
      right: 0;
      height: 100%;
    }
  }

  .antd-pro-pages-dashboard-analysis-salesCard {
    height: calc(50% - 12px);
    /deep/ .ant-card-head {
      position: relative;
    }
  }

  .dashboard-analysis-iconGroup {
    i {
      margin-left: 16px;
      color: rgba(0,0,0,.45);
      cursor: pointer;
      transition: color .32s;
      color: black;
    }
  }
  .analysis-salesTypeRadio {
    position: absolute;
    right: 54px;
    bottom: 12px;
  }
</style>
